import React from 'react';

import { useApolloClient } from '@apollo/client';
import { useRouter } from 'expo-router';
import { useStoreContext } from 'features/store';
import { View } from 'react-native';

import useEffectOnce from 'hooks/use-effect-once';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { useAuthContext } from 'state/auth';
import { useInRestaurantRedemptionContext } from 'state/loyalty/in-restaurant-redemption';
import { useServiceModeContext } from 'state/service-mode';
import logger from 'utils/logger';
import { routes } from 'utils/routing';

function SignOut() {
  const client = useApolloClient();
  const { resetStore } = useStoreContext();
  const { selectServiceMode } = useServiceModeContext();
  const { resetInRestaurantRedemption } = useInRestaurantRedemptionContext();
  const { setOriginLocation, signOut, closeModalAuth } = useAuthContext();

  const router = useRouter();

  useEffectOnce(() => {
    const handleSignOut = async () => {
      try {
        await signOut();
      } catch (error) {
        logger.error({ message: 'An error occurred signing out - SignOut page', error });
      } finally {
        try {
          resetStore();
          resetInRestaurantRedemption();
          selectServiceMode(null);
          setOriginLocation(null);
        } catch (error) {
          logger.error({ message: 'An error occurred cleaning up sign out state', error });
        }

        closeModalAuth();
        router.replace(routes.base);

        client.cache.reset().catch(error => {
          logger.error({
            message: 'An error occurred clearing Apollo cache - SignOut page',
            error,
          });
        });
      }
    };

    void handleSignOut();
  });

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoyaltyLoader />
    </View>
  );
}

export default SignOut;
